/**
 * aplus-content.js
 * Scroll reveal · Before/After slider · Glassmorphism sticky bar
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────
     Scroll reveal
  ───────────────────────────────────────── */
  function initScrollReveal() {
    var els = document.querySelectorAll('.ap-fade-up');
    if (!els.length) return;

    if (!window.IntersectionObserver) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.10, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ─────────────────────────────────────────
     Before / After slider
  ───────────────────────────────────────── */
  function initBASlider() {
    var slider = document.getElementById('ap-ba-slider');
    if (!slider) return;

    var handle = document.getElementById('ap-ba-handle');
    if (!handle) return;

    var dragging = false;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      slider.style.setProperty('--ba-pos', pct + '%');
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    function fromClientX(cx) {
      var r = slider.getBoundingClientRect();
      return r.width ? ((cx - r.left) / r.width) * 100 : 50;
    }

    handle.addEventListener('mousedown',  function (e) { dragging = true; e.preventDefault(); });
    document.addEventListener('mousemove', function (e) { if (dragging) setPos(fromClientX(e.clientX)); });
    document.addEventListener('mouseup',   function ()  { dragging = false; });

    handle.addEventListener('touchstart', function (e) { dragging = true; e.preventDefault(); }, { passive: false });
    document.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      setPos(fromClientX(e.touches[0].clientX));
    }, { passive: false });
    document.addEventListener('touchend', function () { dragging = false; });

    slider.addEventListener('click', function (e) {
      if (!handle.contains(e.target)) setPos(fromClientX(e.clientX));
    });

    handle.addEventListener('keydown', function (e) {
      var curr = parseFloat(slider.style.getPropertyValue('--ba-pos')) || 50;
      if (e.key === 'ArrowLeft')  { setPos(curr - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { setPos(curr + 5); e.preventDefault(); }
    });
  }

  /* ─────────────────────────────────────────
     Premium sticky bar
  ───────────────────────────────────────── */
  function initStickyBar() {
    var bar = document.getElementById('ap-sticky-bar');
    if (!bar) return;

    /* Show when main Add to Cart scrolls out of viewport */
    var anchor = document.getElementById('pp-btn-cart');
    if (anchor && window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(anchor);
    }

    /* Close button */
    var closeBtn = document.getElementById('ap-sticky-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.classList.remove('is-visible');
        /* Re-show after scrolling back up triggers it again */
      });
    }

    /* Quantity */
    var minusBtn = document.getElementById('ap-sq-minus');
    var plusBtn  = document.getElementById('ap-sq-plus');
    var qtyEl    = document.getElementById('ap-sq-val');

    function getQty() { return parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1; }

    function setQty(v) {
      var val = Math.max(1, v);
      if (qtyEl) qtyEl.textContent = val;
      if (minusBtn) minusBtn.disabled = val <= 1;
      var mainInput = document.getElementById('pp-qty-input');
      if (mainInput) {
        mainInput.value = val;
        mainInput.dispatchEvent(new Event('change'));
      }
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { setQty(getQty() - 1); });
    if (plusBtn)  plusBtn.addEventListener('click',  function () { setQty(getQty() + 1); });

    /* Sync variant label */
    function syncVariant() {
      var dest = document.getElementById('ap-sticky-variant');
      var src  = document.getElementById('pp-variant-preview-name');
      if (dest && src) dest.textContent = src.textContent || '';
    }

    var previewEl = document.getElementById('pp-variant-preview-name');
    if (previewEl) {
      new MutationObserver(syncVariant).observe(previewEl, {
        childList: true, characterData: true, subtree: true
      });
      syncVariant();
    }

    /* Delegate click to main buttons (reuse existing cart/buy logic) */
    var stickyAdd = document.getElementById('ap-sticky-add');
    var stickyBuy = document.getElementById('ap-sticky-buy');

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var btn = document.getElementById('pp-btn-cart');
        if (btn && !btn.disabled) btn.click();
      });
    }

    if (stickyBuy) {
      stickyBuy.addEventListener('click', function () {
        var btn = document.getElementById('pp-btn-buy');
        if (btn && !btn.disabled) btn.click();
      });
    }

    /* Mirror disabled state */
    function syncDisabled() {
      var mc = document.getElementById('pp-btn-cart');
      var mb = document.getElementById('pp-btn-buy');
      if (stickyAdd && mc) stickyAdd.disabled = mc.disabled;
      if (stickyBuy && mb) stickyBuy.disabled = mb.disabled;
    }

    var mainCart = document.getElementById('pp-btn-cart');
    if (mainCart) {
      new MutationObserver(syncDisabled)
        .observe(mainCart, { attributes: true, attributeFilter: ['disabled'] });
    }

    setQty(1);
  }

  /* ─────────────────────────────────────────
     Init
  ───────────────────────────────────────── */
  function init() {
    initScrollReveal();
    initBASlider();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
